import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/useAuth';
import { Spin } from 'antd';
import { MandatoryPasswordChange } from './MandatoryPasswordChange';

interface PrivateRouteProps {
  children: React.ReactNode;
}

export const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (user?.access_mode === 'explicit' && user.access_status !== 'active') {
    return <Navigate to="/access-pending" replace />;
  }

  if (user?.must_change_password) {
    return <MandatoryPasswordChange username={user.username} />;
  }

  return <>{children}</>;
};
